import React from 'react';

import useRedux from 'hooks/useRedux';

import { getUserRegion, setUserRegion } from 'helpers/userStorage';

import * as userManagerActions from '../home.duck';

import Login from '../../login/Login';

import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import DropDown from '@material-ui/icons/ArrowDropDown';

import { withStyles } from '@material-ui/core/styles';

import { ListItemIcon, ListItemText } from '@material-ui/core';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import Badge from '@material-ui/core/Badge';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AccountIcon from '@material-ui/icons/AccountCircle';
import SignOutIcon from '@material-ui/icons/ExitToApp';
import NewPortfolioIcon from '@material-ui/icons/Create';
import classnames from 'classnames';

import { hashHistory } from 'browserHistory';

import styled from 'styled-components';

import Flag from 'react-world-flags';

const styles = theme => {
    return ({
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        sectionMobile: {
            display: 'flex',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        headerText: {
            fontSize: 20,
            width: '100%'
        },
        headingButton: {
            color: 'white',
            textTransform: 'initial',
            fontSize: 16,
            marginLeft: 20
        },
        signUpButton: {
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
            borderRadius: 20,
        },
        logInButton: {
            borderColor: 'white',
            borderRadius: 10,
            '&:hover': {
                backgroundColor: '#5a5a5a'
            }
        },
        menuItem: {

        },
        primary: {},
        icon: {},
    })
};

const HidePrint = styled.div`
@media print{
    display: none;
}
`;

const getFlagCode = (region) => {
    return region === 'USD' ? 'USA' : region === 'EUR' ? 'EU' : 'CAN';
};

const Heading = (props) => {

    const { classes, buttons = [],
        showLogin = true,
        showButtons = true,
        maxWidth = 1200 } = props;

    const [{ userManager, shoppingCart }, actions] = useRedux(userManagerActions);

    const [viewLogin, viewLogin_set] = React.useState(false);
    const [viewCreateAccount, viewCreateAccount_set] = React.useState(false);
    const [moreAnchor, moreAnchor_set] = React.useState(null);
    const [accountAnchor, accountAnchor_set] = React.useState(null);
    const [localeAnchor, localeAnchor_set] = React.useState(null);

    React.useEffect(() => {
        actions.initialize();
    }, []);

    var compiledButtons = buttons.slice(0);

    //eslint-disable-next-line
    const mode = _keys ? _keys.mode : '';

    if (showLogin) {
        if (!userManager.user) {
            compiledButtons.push({
                title: 'Log In',
                variant: 'outlined',
                onClick: () => {
                    console.log(viewLogin);

                    viewLogin_set(true);
                }
            });
            compiledButtons.push({
                title: 'Sign Up',
                variant: 'filled',
                onClick: () => {
                    viewCreateAccount_set(true);
                }
            });
        }
        else {
            compiledButtons.push({
                title: 'Sign Out',
                variant: 'icon',
                onClick: (event) => {
                    accountAnchor_set(event.target);
                },
                icon: <AccountIcon style={{ color: 'white' }} />,
                showMobile: true
            });
        }
    }

    shoppingCart.cart.portfolios.length > 0 && compiledButtons.push({
        title: 'Shopping Cart',
        variant: 'icon',
        onClick: (event) => {
            hashHistory.push('/ShoppingCart');
        },
        icon: <Badge badgeContent={shoppingCart.cart.portfolios.length} color="primary">
            <ShoppingCartIcon style={{ color: 'white' }} />
        </Badge>,
        showMobile: true
    });

    compiledButtons.push({
        title: 'Select Region',
        style: { marginTop: -5 },
        variant: 'icon',
        onClick: (event) => {
            localeAnchor_set(event.target);
        },
        icon: <div>
            <Flag code={getFlagCode(getUserRegion())} height={getUserRegion() === 'EUR' ? 20 : 16} />
            <DropDown style={{ color: 'white' }} />
        </div>,
        showMobile: true
    });

    return <HidePrint>
        {(viewLogin || viewCreateAccount) && <div>
            <Login onLoggedIn={(success) => {
                if (success) {
                    // window.location.reload();
                    hashHistory.push(`/`);
                }
                else {
                    viewLogin_set(false);
                    viewCreateAccount_set(false);
                }
            }} showLogin={viewLogin} showCreateAccount={viewCreateAccount} />
        </div>}
        <AppBar position="static" style={{ backgroundColor: '#212224', borderBottom: '1px solid #909090' }}>
            <Toolbar style={{
                margin: '0 auto', maxWidth, width: '100%', padding: 0
            }}>
                <div style={{ cursor: 'pointer' }} onClick={() => {
                    hashHistory.push('/Home')
                }}>
                    <img src='/images/BinocLogo4.png' style={{ height: 60, marginRight: 20, marginTop: 10, marginBottom: 10 }} alt='' />
                </div>
                <div className={classes.headerText}>
                    Portfolio Performance Analyzer
                        {
                        mode !== 'Production' && <div style={{ color: 'red' }}>
                            {mode}
                        </div>
                    }
                </div>
                <div className={classes.sectionDesktop}>

                    {showButtons && compiledButtons.map((e, i) =>
                        <div style={{ whiteSpace: 'nowrap', ...e.style }} key={`menu_${i}`}>
                            {e.variant !== 'icon' &&
                                <Button variant={e.variant === 'outlined' || e.variant === 'filled' ? 'outlined' : 'text'} className={classnames(classes.headingButton, e.variant === 'outlined' && classes.logInButton, e.variant === 'filled' && classes.signUpButton)} onClick={e.onClick}>{e.title}</Button>}
                            {e.variant === 'icon' &&
                                <IconButton onClick={e.onClick}>
                                    {e.icon}
                                </IconButton>
                            }
                        </div>
                    )}
                </div>
                <div className={classes.sectionMobile}>
                    {showButtons && compiledButtons.filter(e => e.showMobile).map((e, i) =>
                        <div style={{ whiteSpace: 'nowrap' }} key={`menu_${i}`}>
                            {e.variant !== 'icon' && <Button variant={e.variant === 'outlined' || e.variant === 'filled' ? 'outlined' : 'text'} className={classnames(classes.headingButton, e.variant === 'outlined' && classes.logInButton, e.variant === 'filled' && classes.signUpButton)} onClick={e.onClick}>{e.title}</Button>}
                            {e.variant === 'icon' &&
                                <IconButton onClick={e.onClick}>
                                    {e.icon}
                                </IconButton>
                            }
                        </div>
                    )}
                    {showButtons && compiledButtons.filter(e => !e.showMobile).length > 0 && <div>
                        <IconButton onClick={(event) => {
                            moreAnchor_set(event.currentTarget);
                        }}>
                            <MenuIcon style={{ color: 'white' }} />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={moreAnchor}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(moreAnchor)}
                            onClose={() => {
                                moreAnchor_set(null)
                            }}
                            disableAutoFocusItem
                        >
                            {compiledButtons.filter(e => !e.showMobile).map((e, i) =>
                                <MenuItem key={`menu_${i}`} onClick={() => {
                                    moreAnchor_set(null);
                                    e.onClick();

                                }}>
                                    {e.title}
                                </MenuItem>
                            )}
                        </Menu>
                    </div>}
                </div>
                <Menu
                    id="locale-account"
                    anchorEl={localeAnchor}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(localeAnchor)}
                    onClose={() => {
                        localeAnchor_set(null)
                    }}
                    disableAutoFocusItem
                >
                    <MenuItem onClick={() => {
                        localeAnchor_set(null);
                        setUserRegion('CAD');
                        window.location.reload();
                    }}>
                        <ListItemIcon className={classes.icon}>
                            <Flag code='CA' height='20' />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} primary="Canada" />
                    </MenuItem>
                    <MenuItem onClick={() => {
                        localeAnchor_set(null);
                        setUserRegion('USD');
                        window.location.reload();
                    }}>
                        <ListItemIcon className={classes.icon}>
                            <Flag code='US' height='20' />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} primary="United States" />
                    </MenuItem>
                    {/* <MenuItem onClick={() => {
                        localeAnchor_set(null);
                        setUserRegion('EUR');
                        window.location.reload();
                    }}>
                        <ListItemIcon className={classes.icon}>
                            <Flag code='EU' height='25' />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} inset primary="E.U." />
                    </MenuItem> */}
                </Menu>
                <Menu
                    id="menu-account"
                    anchorEl={accountAnchor}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(accountAnchor)}
                    onClose={() => {
                        accountAnchor_set(null)
                    }}
                    disableAutoFocusItem
                >
                    <MenuItem onClick={() => {
                        accountAnchor_set(null);
                        hashHistory.push('/Account');
                    }}>
                        <ListItemIcon className={classes.icon}>
                            <AccountIcon />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} primary="My Account" />
                    </MenuItem>
                    <MenuItem onClick={() => {
                        accountAnchor_set(null);
                        
                        if( hashHistory.location.pathname === '/DataEntry'){
                            window.location.reload();
                        }
                        else{
                            hashHistory.push('/DataEntry');
                        }

                        
                    }}>
                        <ListItemIcon className={classes.icon}>
                            <NewPortfolioIcon />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} primary="Create a Portfolio" />
                    </MenuItem>
                    <MenuItem onClick={() => {
                        accountAnchor_set(null);
                        actions.signOut();
                        hashHistory.push('/Home');
                        // hashHistory.push('/Account/SignOut');
                    }}>
                        <ListItemIcon className={classes.icon}>
                            <SignOutIcon />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} primary="Sign Out" />
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    </HidePrint >
}

export default withStyles(styles)(Heading);




// WEBPACK FOOTER //
// ./src/home/components/Heading.js